import { useEffect, useState } from "react";
import Dashboard from "./Dashboard";
import LandingPage from "./LandingPage";
import LoginPage from "./LoginPage";

function normalizePath(path: string) {
  const trimmed = path.replace(/\/+$/, "");
  return trimmed || "/";
}

export function navigate(path: string) {
  if (normalizePath(window.location.pathname) === normalizePath(path)) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0, behavior: "smooth" });
}

const dashboardPaths = new Set(["/quan-ly", "/quan-ly/tong-quan", "/quan-ly/hoc-sinh", "/quan-ly/bao-cao", "/quan-ly/cai-dat", "/quan-ly/huong-dan"]);

export default function App() {
  const [path, setPath] = useState(() => normalizePath(window.location.pathname));

  useEffect(() => {
    const onPopState = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  if (dashboardPaths.has(path)) return <Dashboard page={path.split("/")[2] || "diem"} />;
  if (path === "/dang-nhap") return <LoginPage />;
  return <LandingPage />;
}
